import type { AxiosInstance } from 'axios';

export interface MessageSurvey {
  id: string;
  name: string;
  data: Record<string, unknown>;
  segmentIdentifier: string | null;
  createdOn: string;
  updatedOn: string;
}

export interface CreateSurveyRequest {
  name: string;
  data: Record<string, unknown>;
  segmentIdentifier: string;
}

export interface UpdateSurveyRequest {
  name?: string;
  data?: Record<string, unknown>;
}

export class SurveysClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getSurveys = async (segmentIdentifier: string): Promise<MessageSurvey[]> => {
    const res = await this.authenticatedClient.get<MessageSurvey[]>('/surveys', {
      params: { segmentIdentifier },
    });
    return res.data;
  };

  createSurvey = async (data: CreateSurveyRequest): Promise<MessageSurvey> => {
    const res = await this.authenticatedClient.post<MessageSurvey>('/surveys', data);
    return res.data;
  };

  updateSurvey = async (id: string, data: UpdateSurveyRequest): Promise<MessageSurvey> => {
    const res = await this.authenticatedClient.put<MessageSurvey>(`/surveys/${id}`, data);
    return res.data;
  };
}
